module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"supplier":"Lieferant","period1":"Zeitraum 1","period2":"Zeitraum 2","description":"Beschreibung","price":"Preis","close":"Druckansicht schließen"},"en":{"supplier":"Supplier","period1":"Period 1","period2":"Period 2","description":"Description","price":"Price","close":"Close"}}')
  delete Component.options._Ctor
}
